<ul>
    <li *ngFor="let data of config?.columnData">
        <div *ngIf="!data?.name?.endsWith('.pdf')">
            <img [src]="data?.url" loading="lazy" />
        </div>
        <div>{{ data?.name }}</div>
    </li>
</ul>
